import axiosInstance from "../../utils/axiosInstance";
import { RAG_API_URL } from "../../utils/constants";
import { getLocalResponse } from "./chatKnowledge";
import { normalizeChatPayload } from "./widgetRenderer";

const isRagApiEnabled = () =>
  process.env.REACT_APP_ENABLE_RAG_API === "true";

const normalizeResponse = (response) =>
  normalizeChatPayload({
    status: "success",
    intent: "local",
    reply: response,
    data: {},
    visualization: {
      type: "none",
      title: null,
      x_axis: null,
      y_axis: null,
      series: [],
    },
    insights: [],
    follow_up_questions: [],
    sources: [],
  });

export const getAssistantReply = async (
  message,
  { role, history = [], conversation = null } = {}
) => {
  // 1. Check predefined local questions first.
  const localReply = getLocalResponse(message);

  if (localReply) {
    return normalizeResponse(localReply);
  }

  // 2. Route all other questions to the RAG API.
  if (!isRagApiEnabled()) {
    return {
      ...normalizeResponse(
        "The KTT data assistant is currently unavailable."
      ),
      status: "error",
    };
  }

  try {
    const body = {
      message,
      history,
      role,
    };

    if (conversation?.id) {
      body.conversation_id = conversation.id;
    }
    if (conversation?.dashboard_id) {
      body.dashboard_id = conversation.dashboard_id;
    }
    if (conversation?.revision != null) {
      body.revision = conversation.revision;
    }

    const response = await axiosInstance.post(RAG_API_URL, body);

    return normalizeChatPayload(response.data);
  } catch (error) {
    console.error("KTT RAG API error:", error);

    return {
      ...normalizeResponse(
        "Sorry, I couldn't retrieve the KTT data. Please try again."
      ),
      status: "error",
    };
  }
};
